module.exports = __webpack_public_path__ + "static/media/agbs.40d7bd96.pdf";